module.exports = __webpack_public_path__ + "static/media/strategy.5e9a6207.jpg";